import { EmailModels } from './email.models';

export namespace JobsModels {
  export enum KpiViewMode {
    Count = 1,
    Average,
    Oldest,
    Age,
  }
  export interface EmailMessageJob extends EmailModels.EmailMessage {}

  export interface EmailCounter {
    statusId: number;
    emailMessageQueueId: number;
    countEmail: number;
    countCourrier: number;
    countBroker: number;
    countEscalades: number;
    handlingDurationInDaysEmail: number;
    ageEmail: number;
    handlingDurationInDaysCourrier: number;
    handlingDurationInDaysBroker: number;
    account?: string;
    status?: string;
    queueName: string;
    ageOldestEmail: Date;
  }

  export interface KpiCounter {
    date: string;
    entrant: number;
    sortant: number;
  }

  export interface PolicyControlStat {
    login: string;
    oK: number;
    toDo: number;
    instance: number;
    total: number;
  }

  export interface JobCounter {
    type: JobType;
    count: number;
  }

  export enum JobType {
    Email,
    Request,
    Instance,
    Task,
    Docs,
    DailyFlux,
    Controls,
  }
}
